























import CollapsibleGroup from '@/edinet/components/CollapsibleGroup.vue'
import {JqStyle} from "@/edinet/libs/jq_style";
import $ from "jquery"
import Vue, {PropType} from 'vue'

//deprecated 2021-05-28 - migrated to shortcut and Tools - kept for reference only
export default Vue.extend({
  components: {CollapsibleGroup},
  props: {
    jqRootId: String,
    fontChoices: {
      type: Array as PropType<Array<string>>,
      default: function() {
        return [
          "Roboto",
          "Avenir",
          "Helvetica",
          "Arial",
          "sans-serif"
        ]
      }
    }
  },
  data: function() {
    return {
      font: 'Avenir'
    }
  },
  computed: {
    jqStyle(): JqStyle {
      return new JqStyle(this.jqRootId, 0.15)
    }
  },
  methods: {
    widthUp: function() {
      this.jqStyle.widthUp()
    },
    widthDown: function() {
      this.jqStyle.widthDown()
    },
    fontUp: function() {
      this.jqStyle.fontUp()
    },
    fontDown: function() {
      this.jqStyle.fontDown()
    },
    changeFont: function() {
      $('#app').css('font-family', this.font)
    }
  }
})
